import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAutoMappedStatus = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.5 8.085L2.415 6L1.705 6.705L4.5 9.5L10.5 3.5L9.795 2.795L4.5 8.085Z",
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4 6L3.375 4.625L2 4L3.375 3.375L4 2L4.625 3.375L6 4L4.625 4.625L4 6Z",
		fill: "currentColor"
	})]
});
export default SvgAutoMappedStatus;
